import { ageText } from '../../model/mailboxLevel';
import { byUnread } from '../model/myUnread';
import type { MyMailbox } from '../types';

const LEVEL_DOT: Record<string, string> = { CLEAR: 'bg-emerald-500', NEW: 'bg-blue-500', AGEING: 'bg-amber-500', OVERDUE: 'bg-rose-500' };

function line(m: MyMailbox, now: number): string {
  if (m.status !== 'OK') return m.status === 'PENDING' ? 'Not checked yet' : 'Could not be checked';
  if (!m.unread) return 'All read';
  return `oldest ${ageText(m.oldestUnreadAt, now)}`;
}

/** Each linked mailbox with its count and the age of its oldest unread mail. Counts only, never subjects. */
export function MyMailboxList({ mailboxes, now, compact = false }: { mailboxes: MyMailbox[]; now: number; compact?: boolean }) {
  return (
    <ul className={compact ? 'divide-y divide-slate-100' : 'grid gap-2 sm:grid-cols-2 lg:grid-cols-3'}>
      {byUnread(mailboxes).map((m) => {
        const ok = m.status === 'OK';
        return (
          <li key={m.mailboxId}
            className={compact ? 'flex items-center gap-2 px-3 py-2' : 'flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2'}>
            <span className={`h-2 w-2 shrink-0 rounded-full ${ok && m.level ? LEVEL_DOT[m.level] ?? 'bg-slate-300' : 'bg-slate-300'}`} aria-hidden="true" />
            <span className="min-w-0 flex-1">
              <span className="block truncate text-xs font-bold text-slate-800">{m.address}</span>
              <span className="block truncate text-[11px] text-slate-500">
                {m.role === 'OWNER' ? 'Owner' : 'Member'} · {line(m, now)}
                {!m.remindersOn && ' · reminders off'}
              </span>
            </span>
            <span className={`shrink-0 text-sm font-black tabular-nums ${ok && m.unread ? 'text-rose-600' : 'text-slate-400'}`}>
              {ok ? (m.unread ?? 0) : '—'}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
